import {MODALS_IDS} from '@Components/modal-container';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {GA4EventName, GA4EventParamName} from '@Libraries/ga-events';
import {TicketingComingSoonReasonParam} from '@Libraries/ticketing-ga4.types';

/**
 * The non-US fake door for the Tickets tile and the paid-ticketing step gate. Tracks the view with why it opened
 * (`isCountryBlocked` → the geo-demand signal vs a feature-flag block), then opens the dialog.
 */
export const openTicketingComingSoonModal = (isCountryBlocked: boolean): void => {
  const reason = isCountryBlocked ? TicketingComingSoonReasonParam.NON_US : TicketingComingSoonReasonParam.FEATURE;
  window.PMW.gtm.trackGA4CustomEvent(GA4EventName.EVENTS_TICKETING_COMING_SOON, {[GA4EventParamName.REASON]: reason});
  const {notifyMeEmail} = window.PMW.redux.store.getState().eventWizard;
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.TICKETING_COMING_SOON_MODAL,
      panelProps: {prefillEmail: notifyMeEmail},
    })
  );
};
